import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import Batch from './../../components/Batch/Batch';
import { BatchContext, CourseContext, CommonContext } from './../../contexts/constant/ActionTypes';

const BatchPage = ({history, match}) => {
    const courseContext = useContext(CourseContext);
    const batchContext = useContext(BatchContext);
    const commonContext = useContext(CommonContext);
	return (
		<Batch
			history={history}
			match={match}
            courseContext={courseContext}
			batchContext={batchContext}
            commonContext={commonContext}
		/>
	);
}

BatchPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

BatchPage.defaultProps = {
    history: {},
    match: {}
};

export default BatchPage;



// WEBPACK FOOTER //
// ./containers/BatchPage/BatchPage.js